export default "__VITE_ASSET__aff93581__"